import TaxesPage from '@playground/features/dictionary/TaxesPage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/_superAdmin/dictionary/taxes')({
  component: TaxesPage,
})
